import { render } from "./update_branch_component.vue?vue&type=template&id=b552ad5c&scoped=true"
import script from "./update_branch_component.vue?vue&type=script&lang=js"
export * from "./update_branch_component.vue?vue&type=script&lang=js"

import "./update_branch_component.vue?vue&type=style&index=0&id=b552ad5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b552ad5c"]])

export default __exports__